import { SET_AGE_VALIDITY } from '@/store/mutation-types'

const state = {
  isValidAge: window.localStorage.getItem('isValidAge') === 'true'
}

const mutations = {
  [SET_AGE_VALIDITY] (state, validity) {
    state.isValidAge = validity
    window.localStorage.setItem('isValidAge', validity)
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/ageGate.js